import { render, staticRenderFns } from "./SettingsCollectiveAgreements.vue?vue&type=template&id=532b38b4"
import script from "./SettingsCollectiveAgreements.vue?vue&type=script&lang=js"
export * from "./SettingsCollectiveAgreements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports